import { PayloadAction } from '@reduxjs/toolkit';
import { deleteConsulta } from '../../api/consultes/deleteConsulta';
import { GenericState } from '../../types/apiModule';
import { Consulta } from '../../types/consultes/consulta.d';
import createApiModule from '../createApiModule';
import { showSnackBar } from '../snackBar/snackBarSlice';
import { listConsultesRefresh } from './listConsultaModule';

export interface deleteConsultaState extends GenericState<unknown> {
  active: boolean;
  data: Consulta[];
  consulta: Consulta | null;
}
const initialState: deleteConsultaState = {
  errors: null,
  loading: false,
  data: [],
  active: false,
  consulta: null,
};
const deleteConsultaModule = createApiModule({
  name: 'deleteConsulta',
  initialState,
  apiMethod: deleteConsulta,
  onSuccess: () => [
    showSnackBar({
      severity: 'success',
      message: "La consulta s'ha esborrat correctament.",
    }),
    listConsultesRefresh(),
  ],
  onError: () => ({
    message: 'No es pot esborrar la consulta.',
  }),
  onValidationError: (error) => ({
    message: error ? error.message : 'Error esborrant la consulta',
  }),
  reducers: {
    show(state, action: PayloadAction<Consulta>) {
      state.active = true;
      state.consulta = action.payload;
    },
    hide(state) {
      state.active = false;
    },
  },
});

export const {
  start: del,
  success: delOk,
  error: delKo,
  hide,
  show,
} = deleteConsultaModule.slice.actions;

export default deleteConsultaModule;
